import { CustomerContact } from '../customer-contact';

export interface SalesInvoiceEmailContacts {
  id: string;
  salesInvoiceNo: string;
  emailInvoice: boolean;
  customerInvoiceEmailAddress: string;
  salesInvoiceContactEmailAddress: string;
  sellingCompany: string;
  customerContacts: CustomerContact[];
}
